import { SET_STATUS, SET_TEAM, SET_CHALLENGES, SET_CHALLENGE, SET_CHALLENGE_STATUS } from './actionTypes'

import { PRIZE_TYPE_DOWNLOAD, PRIZE_TYPE_LINK, PRIZE_TYPE_SIMPLE } from './prizeTypes'

import { downloadFile } from '../../mymodules/download'

export function getStatus( fundraiser ) {
   
  return (dispatch, getState) => {
  
    const state = getState()

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.getStatus', { 
      teamId : fundraiser.teamId
    },{
      responseType : 'json',
      callback : function ( status ) {
        
        dispatch( {
          type : SET_STATUS,
          status
        })

      }
    })
  }

}

export function getPublicStatus( fundraiser ) {
   
  return (dispatch, getState) => {
  
    const state = getState()

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.getPublicStatus', { 
      teamId : fundraiser.teamId
    },{
      responseType : 'json',
      callback : function ( status ) {
        
        dispatch( {
          type : SET_STATUS,
          status
        })

      }
    })
  }

}

export function getChallengePrizes( options = [] ) {
   
  return async (dispatch, getState) => {

    const state = getState()

    return new Promise((resolve,reject) => {


      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.getChallengePrizes', { 
        challengeId : options.challengeId,
        participantMissionId : options.participantMissionId,
      },{
        responseType : 'json',
        callback : function ( list ) {
          console.log('fundraiser -  Prize list retrieved')
          resolve(list)
        },
        errorCallback : function (e) {
          reject('fundraiser - retrieving prize list failed')
        }
      })
    
    })
  }

}


export function getPublicChallengeDonors( options = [] ) {
   
  return async (dispatch, getState) => {

    const state = getState()

    return new Promise((resolve,reject) => {


      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.getPublicChallengeDonors', { 
        challengeId : options.challengeId,
        participantMissionId : options.participantMissionId,
        limit: options.limit,
        offset: options.offset
      },{
        responseType : 'json',
        callback : function ( list ) {
          console.log('fundraiser - Donor list retrieved')
          resolve(list)
        },
        errorCallback : function (e) {
          reject('fundraiser - retrieving donor list failed')
        }
      })
    
    })
  }

}

export function getPublicChallengeClassrooms( options = [] ) {
   
  return async (dispatch, getState) => {

    const state = getState()

    return new Promise((resolve,reject) => {


      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.getPublicChallengeClassrooms', { 
        challengeId : options.challengeId,
        participantMissionId : options.participantMissionId,
        limit: options.limit,
        offset: options.offset
      },{
        responseType : 'json',
        callback : function ( list ) {
          console.log('fundraiser - Classroom list retrieved')
          resolve(list)
        },
        errorCallback : function (e) {
          reject('fundraiser - retrieving classroom list failed')
        }
      })
    
    })
  }

}

export function getChallengeBestParticipants( options = [] ) {
   
  return async (dispatch, getState) => {

    const state = getState()

    return new Promise((resolve,reject) => {


      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.getChallengeBestParticipants', { 
        challengeId : options.challengeId,
        participantMissionId : options.participantMissionId,
        limit: options.limit,
        offset: options.offset
      },{
        responseType : 'json',
        callback : function ( list ) {
          console.log('fundraiser - Best Participant list retrieved')
          resolve(list)
        },
        errorCallback : function (e) {
          reject('fundraiser - retrieving Best Participant list failed')
        }
      })
    
    })
  }

}

export function getPublicChallengeStatus( fundraiser ) {
   
  return async (dispatch, getState) => {

    const state = getState()

    return new Promise((resolve,reject) => {


      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.getPublicChallengeStatus', { 
        challengeId : fundraiser.challengeId,
        participantMissionId : fundraiser.participantMissionId
      },{
        responseType : 'json',
        callback : function ( status ) {

          if ( !status.challenge ) {
            reject('Challenge Status not found')
            return false;
          }

          dispatch( {
            type : SET_CHALLENGE_STATUS,
            status
          })
          
          resolve()

        }
      })
    
    })
  }

}

export function createTeam ( team ) {

     
  return (dispatch, getState) => {
  
    const state = getState()

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.createTeam',
      team
    ,{
      responseType : 'json',
      callback : function ( team ) {
        console.log('fundraiser - Team Created')

        dispatch( {
          type:SET_TEAM,
          team
        })
      }
    })
  }

}

export function saveTeam ( team ) {

     
  return (dispatch, getState) => {
  
    const state = getState()

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.saveTeam',
      team
    ,{
      responseType : 'json',
      callback : function ( team ) {
        console.log('fundraiser - Team Saved')

        dispatch( {
          type:SET_TEAM,
          team
        })
      }
    })
  }

}

export function createFundraiser ( fundraiser ) {

     
  return (dispatch, getState) => {
  
    const state = getState()

    return new Promise((resolve,reject) => {

      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.createFundraiser',
        fundraiser
      ,{
        responseType : 'json',
        callback : function ( challengeStatus ) {
          console.log('fundraiser - Fundraiser Created')

          dispatch( {
            type:SET_CHALLENGE,
            challengeStatus
          })

          resolve( challengeStatus.challenge )
        },
        errorCallback: function(e) {
          reject()
        }
      })
    })
  }
}

export function saveFundraiser ( challenge ) {

     
  return async (dispatch, getState) => {
  
    const state = getState()

    return new Promise((resolve,reject) => {

      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.saveFundraiser',
        challenge
      ,{
        responseType : 'json',
        callback : function ( challengeStatus ) {
          console.log('fundraiser - Fundraiser Saved')

          dispatch( {
            type:SET_CHALLENGE,
            challengeStatus
          })

          resolve( challengeStatus.challenge)
        },
        errorCallback: function(e) {
          reject()
        }
      })
    })
  }

}

export function getChallenges( options = {} ) {
  
  return async ( dispatch, getState ) => {

    const state = getState()

    return new Promise((resolve,reject) => {
      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.getChallenges',
      {}
    ,{
      responseType : 'json',
      callback : function ( challenges ) {
        console.log('fundraiser - Challenges retrieved')

        dispatch( {
          type: SET_CHALLENGES,
          challenges
        })

        resolve()
      },
      errorCallback: function (e) {
        reject()
      }

    })

      }
    )
  }

}

export function showPublicChallengePage ( fundraiser ) {

  return (dispatch, getState) => {
  
    const state = getState()

    otuApp.triggerAjaxGet( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.showPublicChallengePage&challengeId=' + fundraiser.id + '&participantMissionId=' + fundraiser.participantMissionId
    )
  }

}

export function showTeacherFundraiserMoreInfo () {
  return (dispatch, getState) => {
  
    const state = getState()

    otuApp.triggerAjaxGet( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=goToStep&step=930'
    )
  }
}

export function showEditChallenge ( challenge ) {

  return (dispatch, getState) => {
  
    const state = getState()

    otuApp.triggerAjaxGet( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.showEditChallenge',{
      data : {
        challengeId : challenge.id,
        participantMissionId : challenge.participantMissionId
      
      }
    })

  }

}

export function sendChallengeEmailLink( options = {} ) {
  
  return async ( dispatch, getState ) => {

    const state = getState()

    const data = {
      email : options.email,
      challengeId : options.challenge.id,
      participantMissionId : options.challenge.participantMissionId
    }

    return new Promise((resolve,reject) => {
      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.sendChallengeEmailLink',
      data
    ,{
      responseType : 'json',
      callback : function ( success ) {
        console.log('fundraiser - Email invite requested',success)
        resolve( success )
      },
      errorCallback: function (e) {
        console.log('fundraiser - Email invite failed')
        reject()
      }

    })

      }
    )
  }

}

export function deleteChallenge( options = {} ) {
   
  return async (dispatch, getState) => {

    const state = getState()

    return new Promise((resolve,reject) => {

      console.log( 'fundraiser - deleting challenge', options)

      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.deleteChallenge', { 
        challengeId : options.challenge.id,
        password : options.password
      },{
        responseType : 'json',
        callback : function ( status ) {

          if ( status.success ) {
            // force a reload of the menubar and got to the profile
            otuApp.unloadMenuBar();
            otuApp.triggerAjaxGet( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=goToProfile' );
            resolve()
          } else {
            reject()
          }

        }
      })
    
    })
  }

}

export function endChallenge( options = {} ) {
   
  return async (dispatch, getState) => {

    const state = getState()

    return new Promise((resolve,reject) => {

      console.log( 'fundraiser - ending challenge', options)

      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.endChallenge', { 
        challengeId : options.challenge.id,
        participantMissionId : options.challenge.participantMissionId,
        password : options.password
      },{
        responseType : 'json',
        callback : function ( challengeStatus ) {
          console.log('fundraiser - Fundraiser Saved')

          dispatch( {
            type:SET_CHALLENGE,
            challengeStatus
          })

          resolve( challengeStatus.challenge)
        },
      })
    
    })
  }

}

export function claimFundraiserPrize( options = {} ) {
   
  return async (dispatch, getState) => {

    const state = getState()

    return new Promise((resolve,reject) => {

      switch ( parseInt(options.prize.prize_type)) {
        case PRIZE_TYPE_LINK:
          console.log( 'fundraiser - Claiming Fundraiser Prize', options)

          otuApp.triggerAjaxGet( options.prize.url,{
            callback : function ( challengeStatus ) {
              console.log('fundraiser - Fundraiser Prize Claimed')
              resolve( )
            },
          })
          break;
        case PRIZE_TYPE_DOWNLOAD:
          downloadFile({ url:options.prize.url })
          resolve( )

          break;
      
      }


    
    })
  }

}

export function signUpTeacher( data ) {
   
  return async (dispatch, getState) => {

    const state = getState()

    return new Promise((resolve,reject) => {

      otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=fundraiser.signupTeacher', data,{
        responseType : 'json',
        callback : function ( response ) {

          if (!response.success) {
            console.log('fundraiser -  Teacher Sign Up Failed Gracefully',response)
            reject(response);
          }
          console.log('fundraiser -  Teacher Signed Up',response)
          resolve(response)
        },
        errorCallback : function ( error) {
          console.log('fundraiser -  Teacher Sign Up Failed NOT Gracefully', error)
          reject(error)
        }
      })
    
    })
  }

}

